var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "chat-window d-flex flex-column chat-window-root" },
    [
      _vm.hasConversa
        ? [
            _c("ChatWindowHeader", {
              attrs: {
                "selected-conversa": _vm.selectedConversa,
                conexoes: _vm.conexoes,
                "show-close-conversa": _vm.showCloseConversa
              },
              on: {
                "open-profile": _vm.onOpenProfile,
                atribuir: _vm.onAtribuir,
                transferir: _vm.onTransferir,
                escalar: _vm.onEscalar,
                fechar: _vm.onFechar,
                "import-history": _vm.onImportHistory,
                "close-conversa": _vm.onCloseConversa
              }
            }),
            _c("ChatWindowMessages", {
              ref: "messages",
              attrs: {
                mensagens: _vm.visibleMensagens,
                "loading-older": _vm.loadingOlder,
                "older-loading-label": _vm.olderLoadingLabel,
                "beginning-of-conversation": _vm.beginningOfConversation,
                loading: _vm.loadingMensagens,
                "linked-task-by-message-id": _vm.linkedTaskByMessageId,
                "has-linked-client": _vm.hasLinkedClient,
                "id-cliente-app": _vm.idClienteApp
              },
              on: {
                scroll: _vm.onScrollMessages,
                retry: _vm.onRetry,
                reply: _vm.onReply,
                edit: _vm.onEdit,
                react: _vm.onReact,
                note: _vm.onNote,
                delete: _vm.onDeleteMessage,
                "create-task": _vm.onCreateTask,
                "send-to-drive": _vm.onSendToDrive,
                "send-to-drive-rename": _vm.onSendToDriveRename,
                "open-task": _vm.onOpenTask,
                "scroll-to-message": _vm.onScrollToMessage
              }
            }),
            _c("ChatInput", {
              ref: "chatInput",
              attrs: {
                value: _vm.messageText,
                disabled: _vm.inputDisabled,
                sending: false
              },
              on: {
                input: function($event) {
                  _vm.messageText = $event
                },
                send: _vm.onSend,
                "send-media": _vm.onSendMedia,
                "edit-message": _vm.onEditMessage,
                "insert-quick-reply": _vm.onInsertQuickReply,
                focus: _vm.onInputFocus
              }
            })
          ]
        : _c("ChatWindowEmptyState", {
            attrs: {
              "conexao-cta": _vm.conexaoCta,
              "can-send-message": _vm.canSendMessage
            },
            on: { "start-nova-conversa": _vm.onStartNovaConversa }
          }),
      _c("ModalProfilePicture", { ref: "profilePicModal" })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }